/**
 * Application version info — injected at build time by vite.config (define block).
 *
 * - APP_VERSION : semver from package.json (or VITE_APP_VERSION override)
 * - GIT_SHA     : short commit hash at build time (or VITE_GIT_SHA override; 'release' if git unavailable)
 * - BUILD_DATE  : ISO date (YYYY-MM-DD) the bundle was built (or VITE_BUILD_DATE override)
 *
 * Shown in the UI (sidebar footer, login footer, Settings ▸ ข้อมูลระบบ) so users can
 * tell support exactly which build they are running when reporting an issue.
 */
declare const __APP_VERSION__: string;
declare const __GIT_SHA__: string;
declare const __BUILD_DATE__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';
export const GIT_SHA: string =
  typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : 'dev';
export const BUILD_DATE: string =
  typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : '';

/** Short label, e.g. "v1.0.0" */
export const VERSION_SHORT: string = `v${APP_VERSION}`;

/** Full label, e.g. "v1.0.0 (edab19f · 2026-05-29)" — for support/troubleshooting */
export const VERSION_LABEL: string = `v${APP_VERSION} (${GIT_SHA}${BUILD_DATE ? ' · ' + BUILD_DATE : ''})`;
